export default {
  clarityResultId: { field: 'clarityResultId' },
  clarityResultCode: { field: 'code' },
  clarityResultName: { field: 'clarityResultName' }
};
